import { api } from '../instance';
export const getPageUsernames = (userId) => {
    return api.get(`/page/page-usernames/${userId}`);
};
//# sourceMappingURL=get-page-usernames.api.js.map